import { LOAD_CATALOGO_SUCCESS, LOAD_CATALOGO_FAIL } from "../actions/catalogo";

const initialState = {
  loja: null,
  produtos: null,
  error: null,
  loading: false,
};

const catalogoReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_CATALOGO_SUCCESS:
      return {
        ...state,
        loja: action.payload.loja,
        produtos: action.payload.produtos, // Agora os produtos são armazenados
        error: null,
      };
    case LOAD_CATALOGO_FAIL:
      return {
        ...state,
        loja: null,
        produtos: null, // Limpa os produtos em caso de erro
        error: action.payload,
      };
    default:
      return state;
  }
};

export default catalogoReducer;
